export default "__VITE_ASSET__DkyC_wjB__"